import { render } from "./detail-blueprint.vue?vue&type=template&id=182caf6a&scoped=true"
import script from "./detail-blueprint.vue?vue&type=script&lang=js"
export * from "./detail-blueprint.vue?vue&type=script&lang=js"

import "./detail-blueprint.vue?vue&type=style&index=0&id=182caf6a&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-182caf6a"]])

export default __exports__